import React from "react";
import s from "./WidgetSpacings.module.css";

const MAP = {
  "top-sm": s["w-spacing-top-sm"],
  "top-md": s["w-spacing-top-md"],
  "top-lg": s["w-spacing-top-lg"],
  "bottom-sm": s["w-spacing-bottom-sm"],
  "bottom-md": s["w-spacing-bottom-md"],
  "bottom-lg": s["w-spacing-bottom-lg"],
  "both-sm": s["w-spacing-both-sm"],
  "both-md": s["w-spacing-both-md"],
  "both-lg": s["w-spacing-both-lg"],
};

function Spacing({ value, children }) {
  return <div className={MAP[value]}>{children}</div>;
}

export default Spacing;
